import { Component, EventEmitter, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-accordion-item',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './accordion-item.component.html'
})
export class AccordionItemComponent {

  @Input()
  public name: string = '';

  @Input()
  public expanded: boolean = false;

  @Input()
  public disabled: boolean = false;

  @Input()
  public onToggle = new EventEmitter<boolean>();

  constructor() {
  }

  public toggle(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    if (!this.disabled) {
      this.expanded = !this.expanded;
      this.onToggle.emit(this.expanded);
    }
  }
}
